import { cn as e } from "../shared/utils.js";
import { InputGroup as t } from "../input/input-group.js";
import { Select as n } from "../select/index.js";
import { changePhoneCountry as r, getCountryCallingCodeValue as i, getCountryDialCodePrefix as a, getPhoneInputChangeDetails as o, getPhoneInputCountryOptions as s, getPhoneInputPlaceholder as c, guessPhoneCountryFromPartialNumber as l, isKnownPhoneCountry as u, resolveFormatCountry as d, resolveInternationalPhonePaste as f, toPublicPhoneInputValue as p } from "./phone-input-utils.js";
import { ChevronDownIcon as m } from "@systemeio/icons";
import { createContext as h, forwardRef as g, useCallback as _, useContext as v, useLayoutEffect as y, useMemo as b, useRef as x, useState as S } from "react";
import { jsx as C, jsxs as w } from "react/jsx-runtime";
import { Field as T } from "@base-ui/react/field";
import E from "react-phone-number-input/flags";
import D from "react-phone-number-input/input-max";
//#region src/phone-input/phone-input.tsx
var O = {}, k = h(null), A = h(null);
function j(e, t) {
	typeof e == "function" ? e(t) : e && (e.current = t);
}
function M() {
	let e = v(k);
	if (!e) throw Error("PhoneInput parts must be rendered inside PhoneInput.Root");
	return e;
}
function N(e) {
	let t = e.currentTarget;
	if (t.value !== "+") return !1;
	let n = t.selectionStart ?? 0, r = t.selectionEnd ?? 0, i = e.key === "Backspace" || e.keyCode === 8, a = e.key === "Delete" || e.keyCode === 46;
	return !i && !a ? !1 : !!(n === 0 && r === 1 || i && n === 1 && r === 1 || a && n === 0 && r === 0);
}
function P(e) {
	return e.key !== "Backspace" && e.keyCode !== 8 ? !1 : e.ctrlKey || e.metaKey || e.altKey;
}
function F(e, t, n) {
	if (t <= 0 || n.metaKey) return 0;
	let r = t;
	for (; r > 0 && /\s/.test(e.charAt(r - 1));) --r;
	if (r === 0) return 0;
	if (/\w/.test(e.charAt(r - 1))) {
		for (; r > 0 && /\w/.test(e.charAt(r - 1));) --r;
		return r;
	}
	for (; r > 0 && !/\w/.test(e.charAt(r - 1)) && !/\s/.test(e.charAt(r - 1));) --r;
	return r;
}
function I(e, t) {
	let n = e.selectionStart ?? 0, r = e.selectionEnd ?? 0, i = e.value;
	if (n !== r) {
		e.value = i.slice(0, n) + i.slice(r), e.setSelectionRange(n, n);
		return;
	}
	let a = F(i, n, t);
	e.value = i.slice(0, a) + i.slice(n), e.setSelectionRange(a, a);
}
var L = g(({ className: t, disabled: n, onChange: r, onKeyDown: i, ...a }, o) => {
	let s = v(A), c = _((e) => {
		j(o, e), j(s?.fieldRef, e), j(s?.controlRef, e);
	}, [
		s?.controlRef,
		s?.fieldRef,
		o
	]);
	return /* @__PURE__ */ C("input", {
		...a,
		ref: c,
		disabled: n,
		"data-disabled": n || void 0,
		"data-slot": "input-group-control",
		className: e("text-text-primary placeholder:text-text-tertiary data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled transition-base h-full min-w-0 flex-1 rounded-md border-0 bg-transparent text-base text-ellipsis outline-none", t),
		onChange: (e) => {
			r?.(e), s?.onChange?.(e);
		},
		onKeyDown: (e) => {
			if (N(e)) {
				e.preventDefault();
				let t = e.currentTarget;
				t.value = "";
				let n = {
					...e,
					target: t,
					currentTarget: t
				};
				r?.(n), s?.onChange?.(n);
				return;
			}
			if (P(e)) {
				e.preventDefault();
				let t = e.currentTarget;
				I(t, { metaKey: e.metaKey });
				let n = {
					...e,
					target: t,
					currentTarget: t
				};
				r?.(n), s?.onChange?.(n);
				return;
			}
			let t = e.currentTarget.value;
			i?.(e), s?.onChange && e.currentTarget.value !== t && s.onChange({
				...e,
				target: e.currentTarget,
				currentTarget: e.currentTarget
			});
		}
	});
});
L.displayName = "PhoneInput.EditableInput";
function R({ country: e, countryName: t }) {
	let n = E[d(e)];
	return n ? /* @__PURE__ */ C("span", {
		"aria-hidden": "true",
		className: "flex size-[18px] shrink-0 items-center justify-center overflow-hidden rounded-full [&>svg]:h-full [&>svg]:w-auto [&>svg]:max-w-none",
		title: t,
		children: /* @__PURE__ */ C(n, { title: "" })
	}) : null;
}
var z = g(({ children: t, className: n, country: r, countryNames: i = O, defaultCountry: a, defaultValue: c = "", disabled: l = !1, form: d, invalid: f = !1, locale: p = "en", name: m, onCountryChange: h, onValueChange: g, readOnly: v = !1, required: y = !1, value: x, ...E }, D) => {
	let A = r !== void 0, j = x !== void 0, [M, N] = S(r ?? a), [P, F] = S(c), I = r ?? M, L = x ?? P;
	if (!u(I)) throw Error(`Unsupported phone country code: ${I}`);
	let R = b(() => s(p, i), [i, p]), z = _((e, t = I) => {
		(e !== L || t !== I) && (j || F(e), g?.(e, o(e, t)));
	}, [
		I,
		j,
		g,
		L
	]), B = _((e, t) => {
		if (!u(e)) throw Error(`Unsupported phone country code: ${e}`);
		A || N(e), h?.(e), z(t, e);
	}, [
		A,
		h,
		z
	]), V = b(() => ({
		country: I,
		countryOptions: R,
		disabled: l,
		form: d,
		invalid: f,
		name: m,
		readOnly: v,
		required: y,
		setCountryAndValue: B,
		setValue: z,
		value: L
	}), [
		I,
		R,
		l,
		d,
		f,
		m,
		v,
		y,
		B,
		z,
		L
	]);
	return /* @__PURE__ */ C(k.Provider, {
		value: V,
		children: /* @__PURE__ */ w(T.Root, {
			ref: D,
			className: e("flex w-full flex-col gap-2", n),
			"data-slot": "phone-input-root",
			disabled: l,
			invalid: f,
			...E,
			children: [t, m && /* @__PURE__ */ C("input", {
				"aria-hidden": "true",
				disabled: l,
				form: d,
				name: m,
				readOnly: !0,
				tabIndex: -1,
				type: "hidden",
				value: L
			})]
		})
	});
}), B = g(({ className: t, ...n }, r) => {
	let { required: i } = M();
	return /* @__PURE__ */ C(T.Label, {
		ref: r,
		className: e("text-text-secondary data-required:after:text-text-error text-base font-medium data-required:after:ml-0.5 data-required:after:content-['*']", t),
		"data-required": i || void 0,
		"data-slot": "phone-input-label",
		...n
	});
}), V = g(({ className: t, ...n }, r) => /* @__PURE__ */ C(T.Description, {
	ref: r,
	className: e("text-text-secondary text-base", t),
	"data-slot": "phone-input-hint",
	...n
})), H = g(({ className: t, ...n }, r) => /* @__PURE__ */ C(T.Error, {
	ref: r,
	className: e("text-text-error text-base", t),
	"data-slot": "phone-input-error",
	match: !0,
	role: "alert",
	...n
})), U = g(({ "aria-describedby": o, "aria-invalid": s, className: d, id: h, onPaste: g, placeholder: v, ...b }, E) => {
	let { country: O, countryOptions: k, disabled: N, form: P, invalid: F, readOnly: I, required: z, setCountryAndValue: B, setValue: V, value: H } = M(), U = i(O), W = k.find((e) => e.code === O)?.name ?? O, ee = v ?? c(O), G = x(H), K = x(!0), q = x(O);
	q.current = O;
	let J = x(null), [te, ne] = S(O), [Y, X] = S(() => H || a(O)), Z = _((e, t, n) => {
		let r = n ?? q.current;
		G.current = e, X(t ?? (e || a(r))), K.current = !0;
	}, []);
	if (O !== te) {
		ne(O);
		let e = J.current, t = e && e.country === O ? e.value : H;
		G.current = t, e?.country === O && e.stayDetached || (X(e && e.country === O ? e.libraryDisplay ?? (t || a(O)) : t || a(O)), K.current = !0);
	}
	y(() => {
		let e = J.current;
		if (!(e && H !== e.value)) {
			if (H !== G.current) {
				Z(H), J.current = null;
				return;
			}
			e?.value === H && (J.current = null);
		}
	}, [Z, H]);
	let Q = x(null), $ = x(!1), re = _((e) => {
		Q.current = e, j(E, e);
	}, [E]), ie = (e) => {
		if (!e || e === O) return;
		let t = r(H, O, e), n = t || a(e);
		J.current = {
			country: e,
			libraryDisplay: n,
			value: t
		}, Z(t, n, e), $.current = !0, B(e, t);
	}, ae = _(() => $.current ? ($.current = !1, Q.current ?? !0) : document.activeElement !== Q.current, []), oe = _((e) => {
		e || queueMicrotask(() => {
			$.current && ($.current = !1, Q.current?.focus());
		});
	}, []), se = (e) => {
		if (g?.(e), e.defaultPrevented) return;
		let t = e.clipboardData.getData("text");
		if (!t.trim().startsWith("+")) return;
		let n = f(t, O);
		n && (e.preventDefault(), J.current = {
			country: n.country,
			value: n.value
		}, Z(n.value, void 0, n.country), B(n.country, n.value));
	}, ce = (e) => {
		if (b.onFocus?.(e), e.defaultPrevented || N || I || H) return;
		let t = a(O);
		Y !== t && Z("", t);
	}, le = _((e) => {
		let t = e ?? "", n = p(e), r = l(t, O), i = r && u(r) ? r : O;
		if (G.current = n, e ? K.current &&= (X(e), !1) : (X((e) => e === void 0 ? e : void 0), K.current = !1), i !== O) {
			J.current = {
				country: i,
				libraryDisplay: n || e || a(i),
				stayDetached: !0,
				value: n
			}, B(i, n);
			return;
		}
		V(n);
	}, [
		O,
		B,
		V
	]);
	return /* @__PURE__ */ w(t.Root, {
		className: e("isolate overflow-visible bg-transparent", d),
		"data-disabled": N || void 0,
		"data-slot": "phone-input-control",
		children: [
			/* @__PURE__ */ C("div", {
				className: "bg-field-bg-secondary transition-base flex h-10 w-[103px] shrink-0 items-center rounded-l-md",
				"data-slot": "phone-input-country",
				children: /* @__PURE__ */ C(T.Root, {
					className: "contents",
					disabled: N,
					children: /* @__PURE__ */ w(n.Root, {
						align: "start",
						disabled: N,
						onOpenChange: oe,
						onValueChange: ie,
						readOnly: I,
						value: O,
						children: [/* @__PURE__ */ w(n.Trigger, {
							"aria-label": `${W} (+${U})`,
							className: "h-10! w-full rounded-none! border-0! bg-transparent! px-3! py-0! shadow-none!",
							children: [/* @__PURE__ */ w("span", {
								className: "flex min-w-0 items-center gap-2.5",
								children: [/* @__PURE__ */ C(R, {
									country: O,
									countryName: W
								}), /* @__PURE__ */ C("span", {
									className: "text-text-secondary text-base",
									children: O
								})]
							}), /* @__PURE__ */ C(n.Icon, { children: /* @__PURE__ */ C(m, {}) })]
						}), /* @__PURE__ */ C(n.Content, {
							className: "tablet:max-h-60 tablet:w-64",
							finalFocus: ae,
							children: /* @__PURE__ */ C(n.List, { children: k.map((e) => /* @__PURE__ */ w(n.Item, {
								label: e.name,
								value: e.code,
								children: [/* @__PURE__ */ C(R, {
									country: e.code,
									countryName: e.name
								}), /* @__PURE__ */ w(n.ItemText, { children: [
									e.name,
									" (+",
									e.callingCode,
									")"
								] })]
							}, e.code)) })
						})]
					})
				})
			}),
			/* @__PURE__ */ C("div", {
				"aria-hidden": "true",
				"data-slot": "phone-input-divider"
			}),
			/* @__PURE__ */ C("div", {
				className: "bg-field-bg-primary transition-base flex h-10 min-w-0 flex-1 items-center rounded-r-md px-3",
				"data-slot": "phone-input-number",
				children: /* @__PURE__ */ C(T.Control, {
					id: h,
					disabled: N,
					render: (e) => {
						let { defaultValue: t, onChange: n, ref: r, value: i, ...a } = e, c = [a["aria-describedby"], o].filter(Boolean).join(" ");
						return /* @__PURE__ */ C(A.Provider, {
							value: {
								controlRef: re,
								fieldRef: r,
								onChange: n
							},
							children: /* @__PURE__ */ C(D, {
								...b,
								...a,
								"aria-describedby": c || void 0,
								"aria-invalid": s ?? a["aria-invalid"] ?? (F || void 0),
								autoComplete: b.autoComplete ?? "tel",
								className: "h-full! min-w-0 flex-1 rounded-none! bg-transparent! px-0! shadow-none!",
								"data-invalid": F || void 0,
								disabled: N,
								form: P,
								inputComponent: L,
								onChange: le,
								onFocus: ce,
								onPaste: se,
								placeholder: ee,
								readOnly: I,
								required: z,
								type: "tel",
								value: Y
							})
						});
					}
				})
			})
		]
	});
});
z.displayName = "PhoneInput.Root", B.displayName = "PhoneInput.Label", U.displayName = "PhoneInput.Control", V.displayName = "PhoneInput.Hint", H.displayName = "PhoneInput.Error";
var W = {
	Root: z,
	Label: B,
	Control: U,
	Hint: V,
	Error: H
};
//#endregion
export { W as PhoneInput };
